import { useEffect, useRef, useState } from "react";

import {
    faAt,
    faBan,
    faCheckCircle,
    faExpand,
    faFileExcel,
    faFilter,
    faHome,
    faLink,
    faPaperclip,
    faTimes,
    faTrash,
    faUndo,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import moment from "moment";
import "moment/locale/pt-br";

import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";

import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";

import {
    BaixarEmailTriagemExcelController,
    DescartarEmailTriagemController,
    AdicionarEmailBlacklistController,
    IgnorarEmailTriagemController,
    ListarEmailBlacklistController,
    ListarEmailsTriagemComFiltroController,
    RemoverEmailBlacklistController,
} from "../../../Controllers/Geral/Triagem/TriagemControllers";
import { IBlacklistEmail, IEmail } from "../../../Interfaces/Geral/Triagem";

import DOMPurify from "dompurify";

import "./styles.css";
import { AbrirAtendimentoSelecionandoTipoCaso } from "../../../Components/CardsPages/Atendimento/AbrirAtendimento";
import VincularEmail from "./VincularEmail";
import { SelecionarTipoCaso } from "../../../Components/CardsPages/Atendimento/AbrirAtendimento/SeletorDeModulo";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import { ACESSOS } from "../../../Routes/Acessos";
import { useHistory, useLocation } from "react-router";
import StickyToolbar from "../../../Components/StickyToolbar";
import { FormProvider, useForm } from "react-hook-form";
import { ITriagem } from "../../../Interfaces/Geral/Email/EmailInterface";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import UnForm from "../../../Components/Form";
import { ListarEmailContaComAcessoController } from "../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import { ListarContatosController } from "../../../Controllers/Geral/Contatos/ContatosController";
import { IContatos } from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import { ListarClientesController } from "../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import CadastrarContato from "../../../Components/CardsPages/ContatosCliente/CadastrarContaContato/CadastrarContato";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import MultSelect from "../../../Components/CardsPages/Forms/MultSelect";
import Swal from "sweetalert2";
import saveAs from "file-saver";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

interface IFilterFormDataInterface {
    DT_INICIAL_IN?: string;
    DT_INICIAL_FN?: string;
    DT_FINAL_IN?: string;
    DT_FINAL_FN?: string;
    DS_STATUS_CASO?: string;
    ID_EMPREENDIMENTO?: number[];
    ID_UNIDADE?: number;
    ID_CASO?: number;
    FL_ANDAMENTO?: number;
    ID_USUARIO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_CATEGORIA_ATENDIMENTO?: number[];
    ID_SUBCATEGORIA?: number;
    ID_CONTA: number;
    ID_ACOMPANHAMENTO?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO?: string[] /* array de arrays 'stringados' - ['8', '12,15,37', '38, 99'] */;
}

const todaysDate = new Date();
//instancia um objeto date de 3 meses antes da data de hoje
const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));
const filtroInicial: ITriagem = {
    DT_CADASTRO_INICIO: pastDate.toISOString().substring(0, 10),
    DT_CADASTRO_FIM: todaysDate.toISOString().substring(0, 10),
    DS_REMETENTE: "",
    DS_ASSUNTO: "",
    ID_PRODUTO: [],
    ID_CONTATO: 0,
    ID_EMAIL_CONTA: 0,
    ID_USUARIO: 0,
    PAGINA: 1,
};

type modulos = "/Geral" | "/Atendimento" | "/Cobranca" | "/AssistenciaTecnica";
const modulo = {
    [ACESSOS.ATENDIMENTO.DS_BASE_URL]: ACESSOS.ATENDIMENTO.ID_MODULO,
    [ACESSOS.COBRANCA.DS_BASE_URL]: ACESSOS.COBRANCA.ID_MODULO,
    [ACESSOS.ASSISTENCIA.DS_BASE_URL]: ACESSOS.ASSISTENCIA.ID_MODULO,
    [ACESSOS.GERAL.DS_BASE_URL]: 0,
};

export function TriagemEmails() {
    const moduloRota = `/${useLocation().pathname.split("/")[1]}` as modulos;
    const FILTRO_TRIAGEM = sessionStorage.getItem("FILTRO_TRIAGEM");

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const [pesquisaText, setPesquisaText] = useState("");

    const FormMethods = useForm<IFilterFormDataInterface>();
    const { reset, control } = FormMethods;
    // const filter = useRef<ITriagem>(
    //     FILTRO_TRIAGEM ? JSON.parse(FILTRO_TRIAGEM) : filtroInicial
    // );

    // eslint-disable-next-line
    const { PageFilter, setPage, filter, setFilter, page } =
        usePaginationFilter<ITriagem>({
            page: 1,
            filter: FILTRO_TRIAGEM ? JSON.parse(FILTRO_TRIAGEM) : filtroInicial,
        });

    const history = useHistory();

    const [lstEmails, setLstEmails] = useState<Array<IBlacklistEmail>>([]);

    const { execute: ListarEmailsBlacklist } = useAsyncCallback(
        ListarEmailBlacklistController
    );

    const updateListEmails = () => {
        ListarEmailsBlacklist().then((res) => {
            setLstEmails(res);
        });
    };

    useEffect(() => {
        updateListEmails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const ID_MODULO = modulo[moduloRota];

    const {
        value: triagemResponse,
        loading,
        execute: updateTriagem,
    } = useAsyncEffect(async () => {
        return ListarEmailsTriagemComFiltroController(
            filter
                ? { ...filter, PAGINA: page, PESQUISA: pesquisaText }
                : filtroInicial,
            ID_MODULO ?? 0
        );
    }, [PageFilter]);

    const totalPaginas = triagemResponse?.NR_TOTAL_PAGINAS || 1;
    const ultimaPesquisaRef = useRef("");

    const searchCliente = (searchValue: string) =>
        ListarClientesController(1, 0, {
            DS_EMAIL: "",
            DS_NOME: searchValue,
            ID_EMPREENDIMENTO: ["0"],
            ID_UNIDADE: 0,
            NR_CPF: "",
            NR_TELEFONE: "",
        }).then((res) => res.LISTA_CLIENTES);

    function handleSearch(
        searchValue: string,
        newState: IPropsTableChange
        // contem: boolean
    ) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                if (filter) {
                    setFilter({
                        ...filter,
                        PESQUISA: newState.searchText,
                        // FL_CONTEM: naoContem,
                        DT_CADASTRO_INICIO: filter?.DT_CADASTRO_INICIO,
                        DT_CADASTRO_FIM: filter?.DT_CADASTRO_FIM,
                    });
                    setPage(newState.page);
                } else {
                    setFilter({
                        ...filtroInicial,
                        PESQUISA: newState.searchText,
                        // FL_CONTEM: naoContem,
                        DT_CADASTRO_INICIO: filtroInicial.DT_CADASTRO_INICIO,
                        DT_CADASTRO_FIM: filtroInicial.DT_CADASTRO_FIM,
                    });
                    setPage(newState.page);
                }
                setPesquisaText(ultimaPesquisaRef.current);
            }
        }, 1500);
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_REMETENTE",
            text: "Emails",
            formatter: row,
            headerFormatter: () => (
                <div className="d-flex align-items-center justify-content-between">
                    <span>Emails</span>
                    <div>
                        <button
                            className="btn btn-danger"
                            onClick={() =>
                                Swal.fire({
                                    title: `Deseja descartar os ${triagemResponse?.LISTA_EMAILS.length} Emails?`,
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        if (filter) {
                                            DescartarEmailTriagemController({
                                                DT_CADASTRO_INICIO:
                                                    filter.DT_CADASTRO_INICIO,
                                                DT_CADASTRO_FIM:
                                                    filter.DT_CADASTRO_FIM,
                                                DS_REMETENTE:
                                                    filter.DS_REMETENTE,
                                                DS_ASSUNTO: filter.DS_ASSUNTO,
                                                ID_PRODUTO: filter.ID_PRODUTO,
                                                ID_CONTATO: filter.ID_CONTATO,
                                                ID_CONTA: filter.ID_CONTA ?? 0,
                                                ID_EMAIL: filter.ID_EMAIL ?? 0,
                                                ID_EMAIL_CONTA:
                                                    filter.ID_EMAIL_CONTA,
                                                ID_USUARIO: filter.ID_USUARIO,
                                                PAGINA: filter.PAGINA,
                                            }).then(() => {
                                                updateTriagem();
                                            });
                                        } else {
                                            DescartarEmailTriagemController({
                                                DT_CADASTRO_INICIO:
                                                    filtroInicial.DT_CADASTRO_INICIO,
                                                DT_CADASTRO_FIM:
                                                    filtroInicial.DT_CADASTRO_FIM,
                                                DS_REMETENTE:
                                                    filtroInicial.DS_REMETENTE,
                                                DS_ASSUNTO:
                                                    filtroInicial.DS_ASSUNTO,
                                                ID_PRODUTO:
                                                    filtroInicial.ID_PRODUTO,
                                                ID_CONTATO:
                                                    filtroInicial.ID_CONTATO,
                                                ID_CONTA:
                                                    filtroInicial.ID_CONTA ?? 0,
                                                ID_EMAIL:
                                                    filtroInicial.ID_EMAIL ?? 0,
                                                ID_EMAIL_CONTA:
                                                    filtroInicial.ID_EMAIL_CONTA,
                                                ID_USUARIO:
                                                    filtroInicial.ID_USUARIO,
                                                PAGINA: filtroInicial.PAGINA,
                                            }).then(() => {
                                                updateTriagem();
                                            });
                                        }
                                    }
                                })
                            }
                        >
                            <FontAwesomeIcon icon={faTrash} /> Descartar todos
                            os Emails{" "}
                        </button>{" "}
                        <button
                            className="btn btn-dark"
                            onClick={() =>
                                history.push(
                                    ACESSOS.GERAL.TELAS.BLACKLIST.DS_PATH
                                )
                            }
                        >
                            <FontAwesomeIcon icon={faBan} /> Ir para Blacklist
                        </button>
                    </div>
                </div>
            ),
        },
    ];

    const handleDateChange = (formData: ITriagem) => {
        const filterFormData: ITriagem = {
            DT_CADASTRO_INICIO:
                formData.DT_CADASTRO_INICIO ||
                (filter && filter.DT_CADASTRO_INICIO
                    ? filter.DT_CADASTRO_INICIO
                    : filtroInicial.DT_CADASTRO_INICIO),
            DT_CADASTRO_FIM:
                formData.DT_CADASTRO_FIM ||
                (filter && filter.DT_CADASTRO_FIM
                    ? filter.DT_CADASTRO_FIM
                    : filtroInicial.DT_CADASTRO_FIM),
            ID_CONTA:
                formData.ID_CONTA && formData.ID_CONTA > 0
                    ? formData.ID_CONTA
                    : 0,
            ID_CONTATO:
                formData.ID_CONTATO && formData.ID_CONTATO > 0
                    ? formData.ID_CONTATO
                    : 0,
            ID_PRODUTO:
                formData.ID_PRODUTO && formData.ID_PRODUTO.length > 0
                    ? formData.ID_PRODUTO
                    : [0],
            ID_EMAIL_CONTA:
                formData.ID_EMAIL_CONTA && formData.ID_EMAIL_CONTA > 0
                    ? formData.ID_EMAIL_CONTA
                    : 0,
            DS_ASSUNTO:
                formData.DS_ASSUNTO && formData.DS_ASSUNTO?.length > 0
                    ? formData.DS_ASSUNTO
                    : "",
            DS_REMETENTE:
                formData.DS_REMETENTE && formData.DS_REMETENTE?.length > 0
                    ? formData.DS_REMETENTE
                    : "",
            ID_EMAIL:
                formData.ID_EMAIL && formData.ID_EMAIL > 0
                    ? formData.ID_EMAIL
                    : 0,
            ID_USUARIO:
                formData.ID_USUARIO && formData.ID_USUARIO > 0
                    ? formData.ID_USUARIO
                    : 0,
            PESQUISA: pesquisaText,
            PAGINA: page,
        };
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_TRIAGEM",
            JSON.stringify(filterFormData)
        );

        //updateTriagem();
    };

    function row(cell: any, row: IEmail) {
        const cleanHTML = DOMPurify.sanitize(row.DS_MENSAGEM);
        const temContatoVinculado = row.ID_CONTA && row.ID_CONTATO;

        const emailNaBlacklist = lstEmails?.some(
            (entry) => entry.DS_EMAIL === row.DS_REMETENTE
        );

        return (
            <div>
                <div className="card">
                    <div className="card-body row">
                        <div className="col-12 d-flex flex-wrap justify-content-between align-items-center mb-2">
                            <div className="d-flex flex-column">
                                <h4 className="mb-0">{row.DS_ASSUNTO}</h4>
                                <h5 className="text-muted text-break">
                                    {row.DS_REMETENTE}
                                </h5>
                            </div>
                            <div>
                                <span
                                    className="label label-light-dark label-inline mr-3"
                                    style={{ height: "auto" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faAt}
                                        className="mr-1"
                                    />{" "}
                                    {row.CONTA_REMETENTE}
                                </span>
                                <div
                                    className="dropdown dropdown-inline"
                                    data-toggle="tooltip"
                                    title=""
                                    data-placement="left"
                                    data-original-title="Quick actions"
                                >
                                    <a
                                        href="#/"
                                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <i className="ki ki-bold-more-hor"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                                        <ul className="navi navi-hover">
                                            {!temContatoVinculado && (
                                                <li
                                                    className="navi-item"
                                                    role="button"
                                                    onClick={() => {
                                                        AbrirAtendimentoSelecionandoTipoCaso(
                                                            setShow,
                                                            setModal,
                                                            {
                                                                ID_MODULO,
                                                                editCliente:
                                                                    true,
                                                                email: {
                                                                    ...row,
                                                                },
                                                                setShow:
                                                                    setShow,
                                                                lockedDocs:
                                                                    row.ANEXOS,
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <span className="navi-link">
                                                        <span className="navi-icon">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faCheckCircle
                                                                }
                                                                className="text-success"
                                                            />
                                                        </span>
                                                        <span className="navi-text">
                                                            Abrir Atendimento
                                                        </span>
                                                    </span>
                                                </li>
                                            )}

                                            {temContatoVinculado ? (
                                                <li
                                                    className="navi-item"
                                                    role="button"
                                                    onClick={() => {
                                                        AbrirAtendimentoSelecionandoTipoCaso(
                                                            setShow,
                                                            setModal,
                                                            {
                                                                ID_MODULO,
                                                                editCliente:
                                                                    true,
                                                                email: {
                                                                    ...row,
                                                                },
                                                                setShow:
                                                                    setShow,
                                                                cliente: {
                                                                    DS_CONTA:
                                                                        row.DS_CONTA,
                                                                    ID_CONTA:
                                                                        row.ID_CONTA,
                                                                    ID_CONTATO:
                                                                        row.ID_CONTATO,
                                                                },
                                                                lockedDocs:
                                                                    row.ANEXOS,
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <span className="navi-link">
                                                        <span className="navi-icon">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faCheckCircle
                                                                }
                                                                className="text-success"
                                                            />
                                                        </span>
                                                        <span className="navi-text">
                                                            Abrir Atendimento
                                                        </span>
                                                    </span>
                                                </li>
                                            ) : (
                                                <li
                                                    className="navi-item"
                                                    role="button"
                                                    onClick={() => {
                                                        setModal({
                                                            Component: () => (
                                                                <CadastrarContato
                                                                    setShow={
                                                                        setShow
                                                                    }
                                                                    update={
                                                                        updateTriagem
                                                                    }
                                                                    email={
                                                                        row.DS_REMETENTE
                                                                    }
                                                                />
                                                            ),
                                                            headerComponent:
                                                                "Criar contato",
                                                            IconHeader: faLink,
                                                        });
                                                        setShow(true);
                                                    }}
                                                >
                                                    <span className="navi-link">
                                                        <span className="navi-icon">
                                                            <FontAwesomeIcon
                                                                icon={faUser}
                                                                className="text-success"
                                                            />
                                                        </span>
                                                        <span className="navi-text">
                                                            Criar Contato
                                                        </span>
                                                    </span>
                                                </li>
                                            )}

                                            <li
                                                className="navi-item"
                                                role="button"
                                                onClick={() => {
                                                    SelecionarTipoCaso(
                                                        setShow,
                                                        setModal,
                                                        (modulo) => {
                                                            setModal({
                                                                Component:
                                                                    () => (
                                                                        <VincularEmail
                                                                            email={
                                                                                row
                                                                            }
                                                                            ID_MODULO={
                                                                                modulo.ID_MODULO
                                                                            }
                                                                            setShow={
                                                                                setShow
                                                                            }
                                                                            update={
                                                                                updateTriagem
                                                                            }
                                                                        />
                                                                    ),
                                                                headerComponent:
                                                                    "Vincular Email a Atendimento",
                                                                IconHeader:
                                                                    faLink,
                                                                size: "lg",
                                                            });
                                                            setShow(true);
                                                        }
                                                    );
                                                }}
                                            >
                                                <span className="navi-link">
                                                    <span className="navi-icon">
                                                        <FontAwesomeIcon
                                                            icon={faLink}
                                                            className="text-primary"
                                                        />
                                                    </span>
                                                    <span className="navi-text">
                                                        Vincular a Atendimento
                                                    </span>
                                                </span>
                                            </li>
                                            <li
                                                className="navi-item"
                                                role="button"
                                                onClick={() => {
                                                    IgnorarEmailTriagemController(
                                                        row.ID_EMAIL
                                                    ).then(updateTriagem);
                                                }}
                                            >
                                                <span className="navi-link">
                                                    <span className="navi-icon">
                                                        <FontAwesomeIcon
                                                            icon={faTrash}
                                                            className="text-danger"
                                                        />
                                                    </span>
                                                    <span className="navi-text">
                                                        Ignorar
                                                    </span>
                                                </span>
                                            </li>
                                            {emailNaBlacklist ? (
                                                <li
                                                    className="navi-item"
                                                    role="button"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title: "Deseja remover esse email da blacklist?",
                                                            icon: "info",
                                                            buttonsStyling:
                                                                false,
                                                            confirmButtonText:
                                                                "<i class='la la-check'></i> Sim!",
                                                            showCancelButton:
                                                                true,
                                                            cancelButtonText:
                                                                "<i class='la la-thumbs-down'></i> Não",
                                                            customClass: {
                                                                confirmButton:
                                                                    "btn btn-outline-success",
                                                                cancelButton:
                                                                    "btn btn-default",
                                                            },
                                                        }).then((result) => {
                                                            if (
                                                                result.isConfirmed
                                                            ) {
                                                                const matchedEntry =
                                                                    lstEmails?.find(
                                                                        (
                                                                            entry
                                                                        ) =>
                                                                            entry.DS_EMAIL ===
                                                                            row.DS_REMETENTE
                                                                    );
                                                                const ID_EMAIL_BLACKLIST =
                                                                    matchedEntry?.ID_EMAIL_BLACKLIST;

                                                                if (
                                                                    ID_EMAIL_BLACKLIST
                                                                ) {
                                                                    RemoverEmailBlacklistController(
                                                                        ID_EMAIL_BLACKLIST
                                                                    ).then(
                                                                        () => {
                                                                            updateTriagem();
                                                                            updateListEmails();
                                                                        }
                                                                    );
                                                                }
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <span className="navi-link">
                                                        <span className="navi-icon">
                                                            <FontAwesomeIcon
                                                                icon={faUndo}
                                                                className="text-dark"
                                                            />
                                                        </span>
                                                        <span className="navi-text">
                                                            Remover da Blacklist
                                                        </span>
                                                    </span>
                                                </li>
                                            ) : (
                                                <li
                                                    className="navi-item"
                                                    role="button"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title: "Deseja mover esse email para a blacklist?",
                                                            icon: "info",
                                                            buttonsStyling:
                                                                false,
                                                            confirmButtonText:
                                                                "<i class='la la-check'></i> Sim!",
                                                            showCancelButton:
                                                                true,
                                                            cancelButtonText:
                                                                "<i class='la la-thumbs-down'></i> Não",
                                                            customClass: {
                                                                confirmButton:
                                                                    "btn btn-outline-success",
                                                                cancelButton:
                                                                    "btn btn-default",
                                                            },
                                                        }).then((result) => {
                                                            if (
                                                                result.isConfirmed
                                                            ) {
                                                                AdicionarEmailBlacklistController(
                                                                    row.DS_REMETENTE
                                                                ).then(() => {
                                                                    updateTriagem();
                                                                    updateListEmails();
                                                                });
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <span className="navi-link">
                                                        <span className="navi-icon">
                                                            <FontAwesomeIcon
                                                                icon={faBan}
                                                                className="text-dark"
                                                            />{" "}
                                                        </span>
                                                        <span className="navi-text">
                                                            Adicionar a
                                                            Blacklist
                                                        </span>
                                                    </span>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <aside className="col-12 col-lg-4">
                            <div className="d-flex flex-lg-column flex-wrap">
                                <div className="mb-2 mr-5">
                                    <div className="d-block font-weight-bold mb-1">
                                        Data de envio
                                    </div>
                                    <div className="label label-light-primary label-inline mr-2 my-1">
                                        {moment(row.DT_CADASTRO).format("lll")}
                                    </div>
                                </div>
                                <div className="mb-2 mr-5">
                                    <h6 className="mb-0">{row.DS_CONTATO}</h6>
                                    <span className="text-muted">
                                        {row.DS_CONTA}
                                    </span>
                                </div>
                                <div className="d-flex flex-nowrap align-items-center mb-2 mr-5">
                                    <div className="symbol symbol-45 symbol-light-danger">
                                        <div className="symbol-label">
                                            <FontAwesomeIcon
                                                icon={faHome}
                                                size="lg"
                                            />
                                        </div>
                                    </div>
                                    <div className="text-left ml-2">
                                        <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                            {row.DS_PRODUTO}
                                        </div>
                                    </div>
                                </div>
                                {row.ANEXOS?.length > 0 && (
                                    <div className="d-flex flex-wrap w-100">
                                        {row.ANEXOS?.map((anexo) => (
                                            <a
                                                className="btn btn-clean d-flex justify-content-between align-items-center g-2"
                                                href={anexo.DS_LINK_DRIVE}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faPaperclip}
                                                />
                                                {anexo.DS_DOCUMENTO?.length > 20
                                                    ? anexo.DS_DOCUMENTO?.substring(
                                                          0,
                                                          20
                                                      ) + "..."
                                                    : anexo?.DS_DOCUMENTO}
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </aside>
                        <main className="col-12 col-lg-8 mt-4 mt-lg-0">
                            <div className="border border-dark h-100 position-relative">
                                <button
                                    className="btn btn-primary rounded-0 position-absolute"
                                    style={{ right: "-1px", top: "-1px" }}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            Component: () => (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: cleanHTML,
                                                    }}
                                                    className="modalHtml"
                                                ></div>
                                            ),
                                            noFooter: true,
                                            noHeader: true,
                                            scrollable: true,
                                            size: "xl",
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faExpand}
                                        className="mr-2"
                                    />{" "}
                                    Expandir
                                </button>
                                <iframe
                                    title={`emailPreview-${row.ID_EMAIL}`}
                                    className="emailPreview"
                                    src={`about:blank`}
                                    srcDoc={cleanHTML}
                                ></iframe>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {triagemResponse?.LISTA_EMAILS ? (
                <Table
                    data={triagemResponse?.LISTA_EMAILS}
                    keyField="ID_EMAIL"
                    columns={columns}
                    loading={loading}
                    noDataIndication={
                        <div className="text-muted text-center">
                            Nenhum email para triar
                        </div>
                    }
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;

                        if (state.searchText !== "") {
                            handleSearch(
                                state.searchText,
                                state
                                // naoContem
                            );
                            setPesquisaText(state.searchText);
                        } else if (pesquisaText.length > 0) {
                            if (filter)
                                setFilter({
                                    ...filter,
                                    PESQUISA: state.searchText,
                                });
                            else
                                setFilter({
                                    ...filtroInicial,
                                    PESQUISA: state.searchText,
                                });
                        } else {
                            setPage(state.page);
                        }

                        //updateTriagem();
                    }}
                    remote={{ pagination: true }}
                    totalPages={totalPaginas}
                    bordered={false}
                    noHover
                />
            ) : loading ? (
                <SpinnerComponent />
            ) : (
                <div className="text-muted text-center">
                    Não foi possível carregar os e-mails recebidos
                </div>
            )}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
            <StickyToolbar active={!!FILTRO_TRIAGEM}>
                <FormProvider {...FormMethods}>
                    <UnForm
                        usingContext
                        handleSubmit={handleDateChange}
                        className="row"
                    >
                        <div className="col-12 mt-3">
                            <div className="row">
                                <div className="col-12">
                                    <UnForm.Input
                                        type="date"
                                        defaultValue={
                                            filter && filter.DT_CADASTRO_INICIO
                                                ? filter.DT_CADASTRO_INICIO
                                                : filtroInicial.DT_CADASTRO_INICIO
                                        }
                                        name="DT_CADASTRO_INICIO"
                                        label="Data de Início"
                                    />
                                </div>
                                <div className="col-12">
                                    <UnForm.Input
                                        type="date"
                                        defaultValue={
                                            filter && filter.DT_CADASTRO_FIM
                                                ? filter.DT_CADASTRO_FIM
                                                : filtroInicial.DT_CADASTRO_FIM
                                        }
                                        registerOptions={{
                                            setValueAs: (strDate) =>
                                                strDate
                                                    ? `${strDate.substring(
                                                          0,
                                                          10
                                                      )}T23:59`
                                                    : "",
                                        }}
                                        name="DT_CADASTRO_FIM"
                                        label="Data de Fim"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <UnForm.SearchSelect
                                controller={searchCliente}
                                getDS={(u) => u.DS_CONTA}
                                name="ID_CONTA"
                                getKeyValue={(u) => u.ID_CONTA}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            {
                                <UnForm.LazySelect
                                    label="Contato"
                                    controller={ListarContatosController}
                                    getDS={(u: IContatos) => u.DS_NOME}
                                    getKeyValue={(u: IContatos) => u.ID_CONTATO}
                                    name="ID_CONTATO"
                                    fatherName="ID_CONTA"
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            }
                        </div>
                        <div className="col-12 mt-3">
                            <label>Produto</label>
                            <MultSelect
                                controller={ListarEmpreendimentosController}
                                getDS={(u) => u.DS_EMPREENDIMENTO}
                                getKeyValue={(u) => u.ID_EMPREENDIMENTO}
                                name="ID_PRODUTO"
                                defaultValue={
                                    filter && filter.ID_PRODUTO
                                        ? filter.ID_PRODUTO
                                        : filtroInicial.ID_PRODUTO
                                }
                                control={control}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <UnForm.LazySelect
                                label="Email do Destinatário"
                                controller={ListarEmailContaComAcessoController}
                                getDS={(u) => u.DS_REMETENTE}
                                getKeyValue={(u) => u.ID_EMAIL_CONTA}
                                name="ID_EMAIL_CONTA"
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="col-12 mt-3">
                            <UnForm.Input
                                type="text"
                                defaultValue={
                                    filter && filter.DS_REMETENTE
                                        ? filter.DS_REMETENTE
                                        : filtroInicial.DS_REMETENTE
                                }
                                name="DS_REMETENTE"
                                label="Remetente"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <UnForm.Input
                                type="text"
                                defaultValue={
                                    filter && filter.DS_ASSUNTO
                                        ? filter.DS_ASSUNTO
                                        : filtroInicial.DS_ASSUNTO
                                }
                                name="DS_ASSUNTO"
                                label="Assunto"
                            />
                        </div>
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    // window.sessionStorage.removeItem(
                                    //     "FILTRO_TRIAGEM"
                                    // );
                                    setFilter(filtroInicial);
                                    reset(filtroInicial);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
            <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-2 mt-22 pb-3 mt-4">
                <li
                    className="nav-item"
                    id="kt_demo_panel_toggle"
                    data-toggle="tooltip"
                    title="ExportExcel"
                    data-placement="right"
                    data-original-title="ExportExcel"
                >
                    <button
                        className={`btn btn-sm btn-icon bg-light btn-hover-success`}
                        onClick={() => {
                            if (filter) {
                                BaixarEmailTriagemExcelController({
                                    DT_CADASTRO_INICIO:
                                        filter.DT_CADASTRO_INICIO,
                                    DT_CADASTRO_FIM: filter.DT_CADASTRO_FIM,
                                    DS_REMETENTE: filter.DS_REMETENTE,
                                    DS_ASSUNTO: filter.DS_ASSUNTO,
                                    ID_PRODUTO: filter.ID_PRODUTO,
                                    ID_CONTATO: filter.ID_CONTATO,
                                    ID_CONTA: filter.ID_CONTA ?? 0,
                                    ID_EMAIL: filter.ID_EMAIL ?? 0,
                                    ID_EMAIL_CONTA: filter.ID_EMAIL_CONTA,
                                    ID_USUARIO: filter.ID_USUARIO,
                                    PAGINA: filter.PAGINA,
                                }).then((res) => {
                                    saveAs(
                                        new Blob([res], {
                                            type: "application/pdf",
                                        }),
                                        "Emails Triagem.xlsx"
                                    );
                                });
                            } else {
                                BaixarEmailTriagemExcelController({
                                    DT_CADASTRO_INICIO:
                                        filtroInicial.DT_CADASTRO_INICIO,
                                    DT_CADASTRO_FIM:
                                        filtroInicial.DT_CADASTRO_FIM,
                                    DS_REMETENTE: filtroInicial.DS_REMETENTE,
                                    DS_ASSUNTO: filtroInicial.DS_ASSUNTO,
                                    ID_PRODUTO: filtroInicial.ID_PRODUTO,
                                    ID_CONTATO: filtroInicial.ID_CONTATO,
                                    ID_CONTA: filtroInicial.ID_CONTA ?? 0,
                                    ID_EMAIL: filtroInicial.ID_EMAIL ?? 0,
                                    ID_EMAIL_CONTA:
                                        filtroInicial.ID_EMAIL_CONTA,
                                    ID_USUARIO: filtroInicial.ID_USUARIO,
                                    PAGINA: filtroInicial.PAGINA,
                                }).then((res) => {
                                    saveAs(
                                        new Blob([res], {
                                            type: "application/pdf",
                                        }),
                                        "Emails Triagem.xlsx"
                                    );
                                });
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faFileExcel} color={"dark"} />
                    </button>
                </li>
            </ul>
        </>
    );
}
